import { IntegrationGroups } from './integrationGroupHandler';

// State machine (reconciliation-first, Stripe is source of truth):
//   Trial (0)    -> Active (1)   : auto-convert at trial end, or user subscribes early
//   Trial (0)    -> Inactive (2) : trial expired with autoConvertOnTrialEnd=false
//   Active (1)   -> Inactive (2) : user cancels, downgrade, or Stripe item removed
//   Inactive (2) -> Active (1)   : user re-subscribes via Store
//
//   Errors are transient (logged server-side), not persisted states.
//   autoConvertOnTrialEnd=false means user cancelled during trial (integrations stay active until trialEndDate).
export enum IntegrationGroupStates {
  Trial = 0,
  Active = 1,
  Inactive = 2,
}

export class IntegrationGroup {
  integrationGroupId: IntegrationGroups;

  state: IntegrationGroupStates;

  autoConvertOnTrialEnd: boolean;

  purchaseDate: Date | undefined;

  trialEndDate: Date | undefined;

  trialNotificationState: number;

  constructor() {
    this.integrationGroupId = IntegrationGroups.NotSet;
    this.state = IntegrationGroupStates.Trial;
    this.autoConvertOnTrialEnd = true;
    this.trialNotificationState = 0;
  }
}
